/*
* API Class
*/

export default class API {
  constructor(id, url) {
    this.id = id;
    this.url = url;
    this.json = {};
  }

  get = async () => {
    const resApi = await fetch(this.url);
    const json = await resApi.json();
    this.json = json;
    return json;    
  }

  post = async (data) => {
    const resApi = await fetch(this.url,{method: 'POST',body: data})
    const json = resApi//.json();
    this.json = json;
    return json;    
  }
}
